// @flow

type Params = {|
    currentPosition: number,
    content: number,
    container: number,
    itemData?: ?{|
        itemOffset: number,
        itemHeight: number,
    |},
|};

/**
 *  @deprecated It will be removed in 6 months 09-15-2025. use `@pb/kit-component-native-scroll`
 *  */
export const scrollIntoViewport = ({currentPosition, content, container, itemData}: Params): number => {
    let position = currentPosition;
    const maxPosition = content - container;
    const isScroll = maxPosition > 0;

    if (!isScroll) {
        return 0;
    }

    if (itemData) {
        const {itemOffset, itemHeight} = itemData;
        if (position > itemOffset) {
            position = itemOffset;
        } else if (position + container < itemOffset + itemHeight) {
            position = itemOffset + itemHeight - container;
        }
    }

    if (position > maxPosition) {
        position = maxPosition;
    }

    return position;
};
